/**
 * Entry point for webpack
 * Import styles, fonts, icons, scripts and other things that your project design requires here
 */

import 'simplebar'
import 'simplebar/dist/simplebar.css'
import objectFitImages from 'object-fit-images'
import svg4everybody from 'svg4everybody'
import barba from '@barba/core'
import carousel from './scripts/init-carousel'
import filters from './scripts/filters'
import form from './form'
import initStickyFooter from './scripts/sticky-animation'
import initScrollTo, { scroll } from './scripts/scroll-to'
import initSelect from './scripts/init-select'
import initScrollHeader from './scripts/scroll-header'
// eslint-disable-next-line import/no-duplicates
import toggleHeaderMenu from './scripts/header'
// eslint-disable-next-line import/no-duplicates
import './scripts/header'
import './scripts/initVideoModal'

import './styles/main.scss'
import './styles/_form.scss'
import './styles/_cta.scss'
import './styles/_blocks.scss'
import './styles/_atomic.scss'
import './styles/_pages.scss'
import './styles/_fonts.scss'

// const preloader = document.querySelector('[data-preloader]')
const header = document.querySelector('.header')

// fix HMR https://github.com/webpack-contrib/grunt-webpack/issues/132#issuecomment-292565027
if (module.hot) {
  module.hot.accept()
}

// initialize things like header, footer
const oneTimeThings = () => {
  // svg sprites support in IE11
  svg4everybody()
  document.documentElement.classList.add('dom-loaded')
  initStickyFooter()
  initScrollHeader()
}

// initialize things inside of data-barba="container"
const onPageLoad = page => {
  // object-fit support in IE11
  objectFitImages()
  form(page)
  // preloader
  // initPreloader()
  filters()

  // init scroll
  page.querySelectorAll('[data-scroll-to]').forEach(initScrollTo)
  // init select
  page.querySelectorAll('[data-select]').forEach(initSelect)
  // init carousel
  page.querySelectorAll('[data-carousel-slider]').forEach(carousel)
}

document.addEventListener('DOMContentLoaded', () => {
  oneTimeThings()

  const container = document.querySelector('[data-barba="container"]')
  onPageLoad(container)

  const enableSmoothTransitions = !document.documentElement.classList.contains(
    'ccm-toolbar-visible'
  )
  if (enableSmoothTransitions) {
    barba.init({
      // If server response is longer then 5s, page will reload completely.
      // You can set bigger values, but in case of long server response user should see something happens.
      timeout: 5000,
      transitions: [
        {
          name: 'sommet',
          beforeLeave() {
            setTimeout(() => toggleHeaderMenu(false), 1000)
          },
          leave() {
            // preloader.classList.remove('loaded')
          },
          enter({ next }) {
            onPageLoad(next.container)
            scroll('top')
          },
        },
        {
          name: 'header',
          to: {
            namespace: ['dark-header'],
          },
          beforeLeave() {
            setTimeout(() => toggleHeaderMenu(false), 1000)
          },
          leave() {
            // preloader.classList.remove('loaded')
          },
          beforeEnter() {
            header.classList.remove('white')
          },
          enter({ next }) {
            onPageLoad(next.container)
            scroll('top')
          },
        },
        {
          name: 'header',
          to: {
            namespace: ['white-header'],
          },
          beforeLeave() {
            setTimeout(() => toggleHeaderMenu(false), 1000)
          },
          leave() {
            // preloader.classList.remove('loaded')
          },
          beforeEnter() {
            header.classList.add('white')
          },
          enter({ next }) {
            onPageLoad(next.container)
            scroll('top')
          },
        },
      ],
    })
  }
})

// to avoid wrong calculation of swiper slide width
window.addEventListener(
  'load',
  () => {
    const container = document.querySelector('[data-barba="container"]')
    // init carousel
    container.querySelectorAll('[data-carousel-slider]').forEach(carousel)
  },
  false
)
